import { Col, Form, Divider } from 'antd';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';
import { CustomSwitch } from '../../SelfScheduling/components/form/editScheduleBlocks/CustomSwitch';
import { TitleFormDefault } from '../../../container/styled';

const FormSupervisor = () => {
  const { translate: t } = useDictionaryTranslation();

  return (
    <>
      <Divider />
      <Col xs={10} md={20}>
        <TitleFormDefault>{t('usersModule')}</TitleFormDefault>
        <Form.Item name="canManageUsers" label={t('canManageUsersDescription')} valuePropName="checked">
          <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
        </Form.Item>
      </Col>
    </>
  );
};

export default FormSupervisor;
